<template>
  <div v-loading="loading">
    <div class="btn-tags">
      <el-radio-group v-model="pgData.releaseDept" @input="changePolicy">
        <el-radio-button style="width: 88px;" v-for="(item,index) in releaseDepts" :key="index"
                         :label="item.releaseDept"></el-radio-button>
      </el-radio-group>
    </div>
    <div class="card-wrap">
      <template v-if="tableData.length>0">
        <standardList
          v-for="(iteme, index) in tableData"
          :key="index"
          :data="iteme"
          detail="/yzkj/standard/detail"
        ></standardList>
        <div v-if="tableData.length===8" class="lookMore" @click="lookMore">查看更多&gt;</div>
      </template>
      <template v-else>
        <div class="card-empty">暂无数据</div>
      </template>
    </div>

  </div>
</template>

<script>
import utils from "@mixins/utils";
import standardList from "../section/standard-list.vue";

export default {
  mixins: [utils],
  components: {
    standardList
  },
  data() {
    return {
      title: "",
      loading: false,
      tableData: [], //标准规范
      pgData: {
        pageIndex: 1,
        pageSize: 8,
        sortOrder: "ASC",
        sourceStr: "",
        title: "",
        releaseDept: "国家标准",
        pageType: "index"
      },
      releaseDepts: [
        {
          releaseDept: "国家标准",
        },
        {
          releaseDept: "地方标准",
        },
        {
          releaseDept: "行业标准",
        },
        {
          releaseDept: "团体标准",
        }
      ]
    };
  },
  methods: {
    changePolicy(val) {
      const obj = this.releaseDepts.filter(item => {
        return item.releaseDept == val;
      })[0]
      this.$set(this.pgData, 'releaseDept', obj.releaseDept)
      this.$nextTick(() => {
        this.getData();
      })
    },
    getData() {
      return new Promise(
        (resolve, reject) => {
          this.loading = true;
          this.$ajax({
            url: `${this.$store.state.api.baseWebUrl}/yzkj/standard/search`,
            data: this.pgData,
            callback: data => {
              this.tableData = data.rows;
              resolve(data); // 成功时返回数据
            },
            error: err => {
              reject(err); // 失败时抛出错误
            },
            complete: () => {
              this.loading = false;
            }
          });
        });
    },
    // 查看更多
    lookMore() {
      window.location.assign('/standard');
    },
  },
};
</script>

<style scoped lang="scss">
.card-wrap {
  padding: 17px 20px 22px 19px;
  border-radius: 8px;
  background: #FFFFFF;
  margin-top: 16px;
  height: 324px;
}

.card-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-weight: 400;
  font-size: 14px;
  color: #aaa;
  text-align: center;
  padding-top: 20px;
}

.lookMore {
  margin-top: 15px;
  text-align: center;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
</style>

